var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-field-widget-logo"},[_c('img',{attrs:{"src":_vm.logo,"alt":_vm.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }